import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  housingStocks: [],
  getHousingStocksStatus: IDLE,

  createHousingStockStatus: IDLE,
  updateHousingStockStatus: IDLE,
  deleteHousingStockStatus: IDLE
};

const housingStocksSlice = createSlice({
  name: 'housingStocks',
  initialState,
  reducers: {
    getHousingStocks(state) {
      state.getHousingStocksStatus = LOADING;
    },
    getHousingStocksSucceeded(state, action) {
      state.housingStocks = action.payload;
      state.getHousingStocksStatus = SUCCEEDED;
    },
    getHousingStocksFailed(state) {
      state.getHousingStocksStatus = FAILED;
    },

    createHousingStock(state) {
      state.createHousingStockStatus = LOADING;
    },
    createHousingStockSucceeded(state) {
      state.createHousingStockStatus = SUCCEEDED;
    },
    createHousingStockFailed(state) {
      state.createHousingStockStatus = FAILED;
    },

    updateHousingStock(state) {
      state.updateHousingStockStatus = LOADING;
    },
    updateHousingStockSucceeded(state) {
      state.updateHousingStockStatus = SUCCEEDED;
    },
    updateHousingStockFailed(state) {
      state.updateHousingStockStatus = FAILED;
    },

    deleteHousingStock(state) {
      state.deleteHousingStockStatus = LOADING;
    },
    deleteHousingStockSucceeded(state) {
      state.deleteHousingStockStatus = SUCCEEDED;
    },
    deleteHousingStockFailed(state) {
      state.deleteHousingStockStatus = FAILED;
    }
  }
});

export const {
  getHousingStocks,
  getHousingStocksSucceeded,
  getHousingStocksFailed,
  createHousingStock,
  createHousingStockSucceeded,
  createHousingStockFailed,
  updateHousingStock,
  updateHousingStockSucceeded,
  updateHousingStockFailed,
  deleteHousingStock,
  deleteHousingStockSucceeded,
  deleteHousingStockFailed
} = housingStocksSlice.actions;

export default housingStocksSlice.reducer;
